






import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({ name: 'settings-header' })
export default class SettingsHeader extends Vue {
    /**
     * Element type
     */
    @Prop({ type: String, default: 'h1' })
    el!: string

    @Prop({ type: String, default: 'default' })
    type!: string
}
